var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideshow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "slideshow_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#slideshow_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 10.313a.359.359 0 00.167-.317.341.341 0 00-.167-.309L8.583 6.876a.346.346 0 00-.385-.016.353.353 0 00-.198.329v5.618c0 .157.066.27.198.34s.26.062.385-.021L13 10.312zM4.5 17c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 15.5v-11c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44h11c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06v11c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-11z",
    fill: "#fff"
  }))));
}
export default SvgSlideshow;